import { useDataProvider } from "ra-core";
import { useEffect, useState } from "react";

const useOneMember = (id) => {
  const [member, setMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();
  useEffect(() => {
    async function getOneMember(id) {
      try {
        const member = await dataProvider.getOne("members", { id: id });
        setMember(member.data);

        return setLoading(false);
      } catch (error) {
        setError("Please try to login again");
        return setLoading(false);
      }
    }

    setLoading(true);
    getOneMember(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { member, loading, error };
};

export default useOneMember;
